module.exports = __webpack_public_path__ + "img/windows-logo.5ce03d81.png";